import { FC, lazy, Suspense } from 'react';

import { SkeletonLoader } from 'components/_basic/SkeletonLoader';

const OnePageFirstStyleLazy = lazy(() => import('./OnePageFirstStyle'));

export const OnePageFirstStyleView: FC = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <OnePageFirstStyleLazy />
    </Suspense>
  );
};
